import { useTrackEvent } from "kanopi-components/tracking";
import { useGlobal } from "kanopi-components/useGlobal";

export function useTrackViewCoverLimitations({ ...args } = {}) {
  const _trackWhatsCoveredViewed = useTrackEvent({
    event: "Whats Covered Viewed",
    now: false,
    ...args,
  });
  const [data] = useGlobal("tracking");
  return function trackWhatsCoveredViewed({ ...other }: object = {}) {
    _trackWhatsCoveredViewed({
      properties: {
        riskProfileId: data?.riskProfile?.id,
        enabledCoverSections: data?.enabledCoverSections,
        ...args,
        ...other,
      },
    });
  };
}
